import axios from "axios";
import Swal from "sweetalert2";
import { t } from "i18next";
import store from "../store";

const axiosClient = axios.create({
    timeout: 30000,
});

axiosClient.interceptors.request.use(
    (config) => {
        const state = store.getState();
        const token = state.user.token;

        if (token) {
            config.headers["al-token"] = token;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosClient.interceptors.response.use(
    (response) => response?.data?.data,
    (error) => {
        Swal.fire(t("Error"), t("An error occurred!"), "error");

        return Promise.reject(error);
    }
);

export default axiosClient;
